import AccountPausePage from './AccountPausePage'

export default AccountPausePage
// eslint-disable-next-line import/export
export * from './AccountPausePage'
